/* tslint:disable */
/* eslint-disable */
/**
 * BusService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
/**
 * CityListApiApiCityListGet - axios parameter creator
 * 
 * @param {number} [fromProvince] 
 * @param {number} [fromCity] 
 * @param {number} [toProvince] 
 * @param {boolean} [getCities] 
 * @param {boolean} [disableCache] 
 * @param {boolean} [groupTerminals] 
 * @param {number} [providerId] 
 * @param {boolean} [domestic] 
 * @param {boolean} [includePopular] 
 * @param {string} [includeCity] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CityListApiApiCityListGetAxiosParamCreator (fromProvince?: number, fromCity?: number, toProvince?: number, getCities?: boolean, disableCache?: boolean, groupTerminals?: boolean, providerId?: number, domestic?: boolean, includePopular?: boolean, includeCity?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/CityList`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (fromProvince !== undefined) {
        localVarQueryParameter['fromProvince'] = fromProvince;
    }

    if (fromCity !== undefined) {
        localVarQueryParameter['fromCity'] = fromCity;
    }

    if (toProvince !== undefined) {
        localVarQueryParameter['toProvince'] = toProvince;
    }

    if (getCities !== undefined) {
        localVarQueryParameter['getCities'] = getCities;
    }

    if (disableCache !== undefined) {
        localVarQueryParameter['disableCache'] = disableCache;
    }

    if (groupTerminals !== undefined) {
        localVarQueryParameter['groupTerminals'] = groupTerminals;
    }

    if (providerId !== undefined) {
        localVarQueryParameter['providerId'] = providerId;
    }

    if (domestic !== undefined) {
        localVarQueryParameter['domestic'] = domestic;
    }

    if (includePopular !== undefined) {
        localVarQueryParameter['includePopular'] = includePopular;
    }

    if (includeCity !== undefined) {
        localVarQueryParameter['includeCity'] = includeCity;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * CityListApiApiCityListGetBusCityListGet - axios parameter creator
 * 
 * @param {number} [fromProvince] 
 * @param {number} [fromCity] 
 * @param {number} [toProvince] 
 * @param {boolean} [getCities] 
 * @param {boolean} [disableCache] 
 * @param {boolean} [groupTerminals] 
 * @param {boolean} [domestic] 
 * @param {boolean} [includePopular] 
 * @param {string} [includeCity] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CityListApiApiCityListGetBusCityListGetAxiosParamCreator (fromProvince?: number, fromCity?: number, toProvince?: number, getCities?: boolean, disableCache?: boolean, groupTerminals?: boolean, domestic?: boolean, includePopular?: boolean, includeCity?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/CityList/GetBusCityList`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (fromProvince !== undefined) {
        localVarQueryParameter['fromProvince'] = fromProvince;
    }

    if (fromCity !== undefined) {
        localVarQueryParameter['fromCity'] = fromCity;
    }

    if (toProvince !== undefined) {
        localVarQueryParameter['toProvince'] = toProvince;
    }

    if (getCities !== undefined) {
        localVarQueryParameter['getCities'] = getCities;
    }

    if (disableCache !== undefined) {
        localVarQueryParameter['disableCache'] = disableCache;
    }

    if (groupTerminals !== undefined) {
        localVarQueryParameter['groupTerminals'] = groupTerminals;
    }

    if (domestic !== undefined) {
        localVarQueryParameter['domestic'] = domestic;
    }

    if (includePopular !== undefined) {
        localVarQueryParameter['includePopular'] = includePopular;
    }

    if (includeCity !== undefined) {
        localVarQueryParameter['includeCity'] = includeCity;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * CityListApiApiCityListGetTaxiCityListGet - axios parameter creator
 * 
 * @param {number} [fromProvince] 
 * @param {number} [fromCity] 
 * @param {number} [toProvince] 
 * @param {boolean} [getCities] 
 * @param {boolean} [disableCache] 
 * @param {boolean} [groupTerminals] 
 * @param {boolean} [domestic] 
 * @param {boolean} [includePopular] 
 * @param {string} [includeCity] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function CityListApiApiCityListGetTaxiCityListGetAxiosParamCreator (fromProvince?: number, fromCity?: number, toProvince?: number, getCities?: boolean, disableCache?: boolean, groupTerminals?: boolean, domestic?: boolean, includePopular?: boolean, includeCity?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/CityList/GetTaxiCityList`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (fromProvince !== undefined) {
        localVarQueryParameter['fromProvince'] = fromProvince;
    }

    if (fromCity !== undefined) {
        localVarQueryParameter['fromCity'] = fromCity;
    }

    if (toProvince !== undefined) {
        localVarQueryParameter['toProvince'] = toProvince;
    }

    if (getCities !== undefined) {
        localVarQueryParameter['getCities'] = getCities;
    }

    if (disableCache !== undefined) {
        localVarQueryParameter['disableCache'] = disableCache;
    }

    if (groupTerminals !== undefined) {
        localVarQueryParameter['groupTerminals'] = groupTerminals;
    }

    if (domestic !== undefined) {
        localVarQueryParameter['domestic'] = domestic;
    }

    if (includePopular !== undefined) {
        localVarQueryParameter['includePopular'] = includePopular;
    }

    if (includeCity !== undefined) {
        localVarQueryParameter['includeCity'] = includeCity;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiCityListGet operation in CityListApi.
 * @export
 * @interface CityListApiApiCityListGetRequest
 */
export interface CityListApiApiCityListGetRequest {
    /**
     * 
     * @type {number}
     * @memberof CityListApiApiCityListGet
     */
    readonly fromProvince?: number

    /**
     * 
     * @type {number}
     * @memberof CityListApiApiCityListGet
     */
    readonly fromCity?: number

    /**
     * 
     * @type {number}
     * @memberof CityListApiApiCityListGet
     */
    readonly toProvince?: number

    /**
     * 
     * @type {boolean}
     * @memberof CityListApiApiCityListGet
     */
    readonly getCities?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CityListApiApiCityListGet
     */
    readonly disableCache?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CityListApiApiCityListGet
     */
    readonly groupTerminals?: boolean

    /**
     * 
     * @type {number}
     * @memberof CityListApiApiCityListGet
     */
    readonly providerId?: number

    /**
     * 
     * @type {boolean}
     * @memberof CityListApiApiCityListGet
     */
    readonly domestic?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CityListApiApiCityListGet
     */
    readonly includePopular?: boolean

    /**
     * 
     * @type {string}
     * @memberof CityListApiApiCityListGet
     */
    readonly includeCity?: string
}

/**
 * Request parameters for apiCityListGetBusCityListGet operation in CityListApi.
 * @export
 * @interface CityListApiApiCityListGetBusCityListGetRequest
 */
export interface CityListApiApiCityListGetBusCityListGetRequest {
    /**
     * 
     * @type {number}
     * @memberof CityListApiApiCityListGetBusCityListGet
     */
    readonly fromProvince?: number

    /**
     * 
     * @type {number}
     * @memberof CityListApiApiCityListGetBusCityListGet
     */
    readonly fromCity?: number

    /**
     * 
     * @type {number}
     * @memberof CityListApiApiCityListGetBusCityListGet
     */
    readonly toProvince?: number

    /**
     * 
     * @type {boolean}
     * @memberof CityListApiApiCityListGetBusCityListGet
     */
    readonly getCities?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CityListApiApiCityListGetBusCityListGet
     */
    readonly disableCache?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CityListApiApiCityListGetBusCityListGet
     */
    readonly groupTerminals?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CityListApiApiCityListGetBusCityListGet
     */
    readonly domestic?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CityListApiApiCityListGetBusCityListGet
     */
    readonly includePopular?: boolean

    /**
     * 
     * @type {string}
     * @memberof CityListApiApiCityListGetBusCityListGet
     */
    readonly includeCity?: string
}

/**
 * Request parameters for apiCityListGetTaxiCityListGet operation in CityListApi.
 * @export
 * @interface CityListApiApiCityListGetTaxiCityListGetRequest
 */
export interface CityListApiApiCityListGetTaxiCityListGetRequest {
    /**
     * 
     * @type {number}
     * @memberof CityListApiApiCityListGetTaxiCityListGet
     */
    readonly fromProvince?: number

    /**
     * 
     * @type {number}
     * @memberof CityListApiApiCityListGetTaxiCityListGet
     */
    readonly fromCity?: number

    /**
     * 
     * @type {number}
     * @memberof CityListApiApiCityListGetTaxiCityListGet
     */
    readonly toProvince?: number

    /**
     * 
     * @type {boolean}
     * @memberof CityListApiApiCityListGetTaxiCityListGet
     */
    readonly getCities?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CityListApiApiCityListGetTaxiCityListGet
     */
    readonly disableCache?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CityListApiApiCityListGetTaxiCityListGet
     */
    readonly groupTerminals?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CityListApiApiCityListGetTaxiCityListGet
     */
    readonly domestic?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof CityListApiApiCityListGetTaxiCityListGet
     */
    readonly includePopular?: boolean

    /**
     * 
     * @type {string}
     * @memberof CityListApiApiCityListGetTaxiCityListGet
     */
    readonly includeCity?: string
}

/**
* 
* @param {CityListApiApiCityListGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CityListApiApiCityListGet(requestParameters: CityListApiApiCityListGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CityListApiApiCityListGetAxiosParamCreator(requestParameters.fromProvince, requestParameters.fromCity, requestParameters.toProvince, requestParameters.getCities, requestParameters.disableCache, requestParameters.groupTerminals, requestParameters.providerId, requestParameters.domestic, requestParameters.includePopular, requestParameters.includeCity, options, configuration);
    const request: () => AxiosPromise<Array<any>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {CityListApiApiCityListGetBusCityListGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CityListApiApiCityListGetBusCityListGet(requestParameters: CityListApiApiCityListGetBusCityListGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CityListApiApiCityListGetBusCityListGetAxiosParamCreator(requestParameters.fromProvince, requestParameters.fromCity, requestParameters.toProvince, requestParameters.getCities, requestParameters.disableCache, requestParameters.groupTerminals, requestParameters.domestic, requestParameters.includePopular, requestParameters.includeCity, options, configuration);
    const request: () => AxiosPromise<Array<any>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {CityListApiApiCityListGetTaxiCityListGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function CityListApiApiCityListGetTaxiCityListGet(requestParameters: CityListApiApiCityListGetTaxiCityListGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await CityListApiApiCityListGetTaxiCityListGetAxiosParamCreator(requestParameters.fromProvince, requestParameters.fromCity, requestParameters.toProvince, requestParameters.getCities, requestParameters.disableCache, requestParameters.groupTerminals, requestParameters.domestic, requestParameters.includePopular, requestParameters.includeCity, options, configuration);
    const request: () => AxiosPromise<Array<any>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
